module.exports = __webpack_public_path__ + "static/media/right.76525ed8.ts";